import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppRoutes } from '@helpers/app-routes';
import { AuthService } from '@services/auth.service';
import { LoadingService } from '@services/loading.service';

@Injectable({
  providedIn: 'root',
})
export class EnsureUserIsAuthenticated implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private loadingService: LoadingService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    try {
      // Afficher le loader avec un message personnalisé
      if (!this.authService.isInitialized()) {
        this.loadingService.setLoading(true, "Initialisation du service d'authentification...");
      }
      // Attendre que le service soit initialisé
      await this.authService.waitForInitialization();
      const isLoggedIn = this.authService.isLogged();

      if (!isLoggedIn) {
        // L'utilisateur n'est pas connecté, on redirige vers la page de login
        void this.router.navigate([AppRoutes.login]);
        return false;
      }

      // L'utilisateur est connecté
      return true;
    } finally {
      // Cacher le loader dans tous les cas
      this.loadingService.setLoading(false);
    }
  }
}
